import { render, staticRenderFns } from "./AddQuestion.vue?vue&type=template&id=07b66c44&"
import script from "./AddQuestion.vue?vue&type=script&lang=ts&"
export * from "./AddQuestion.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('07b66c44')) {
      api.createRecord('07b66c44', component.options)
    } else {
      api.reload('07b66c44', component.options)
    }
    module.hot.accept("./AddQuestion.vue?vue&type=template&id=07b66c44&", function () {
      api.rerender('07b66c44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/groups/questions/AddQuestion.vue"
export default component.exports